import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RequestService {
    /**
     * Create a new actionRequest document
     * @param requestBody
     * @returns ActionRequestBoInterface
     * @throws ApiError
     */
    static requestCreate(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/request',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create multiple new actionRequest documents
     * @param requestBody
     * @returns ActionRequestBoInterface
     * @throws ApiError
     */
    static requestCreateBulk(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/request/bulk',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update configs by action requests
     * @param requestBody
     * @returns ActionRequestBoInterface
     * @throws ApiError
     */
    static requestUpdateBulk(requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/request/configs',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get actionRequest by ID
     * @param requestId
     * @returns ActionRequestBoInterface
     * @throws ApiError
     */
    static requestGetById(requestId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/request/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * Archive an actionRequest
     * @param requestId
     * @returns boolean
     * @throws ApiError
     */
    static requestDelete(requestId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/request/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * Get results by request id
     * @param requestId
     * @returns ActionResultBoInterface
     * @throws ApiError
     */
    static requestGetResults(requestId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/request/{requestId}/results',
            path: {
                'requestId': requestId,
            },
        });
    }
}
